import React, { useContext } from 'react';
import { Layout, Menu, Breadcrumb } from 'antd';
import 'antd/dist/antd.css';

import AppRouter from './AppRouter';
import NavigationApp from './NavigationApp';
import Login from './Login';

import { AppContext } from 'context/AppContext';
import DefaultsLoad from './DefaultsLoad';

const LayoutApp = () => {
    const { Content, Header, Footer } = Layout;
    const appContext = useContext(AppContext);
    return (
        <>
            {appContext.accessToken ? (
                appContext.defaults ? (
                    <Layout>
                        <NavigationApp />
                        <Layout>
                            <Layout>
                                <Content
                                    className="site-layout-background"
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                        minHeight: '800px',
                                        backgroundColor: 'white'
                                    }}
                                >
                                    <AppRouter />
                                </Content>
                            </Layout>
                        </Layout>
                    </Layout>
                ) : (
                    <DefaultsLoad />
                )
            ) : (
                <Login />
            )}
        </>
    );
};

export default LayoutApp;
